module.exports = __webpack_public_path__ + "fonts/Mukta-700-devanagari16.2dfa823.woff2";